<template>
    <div class="vx-col w-full mb-base flex">
      <div class="flex-1 px-2">
        <vx-card>
          <vs-table pagination :max-items="10" search :data="contracts">
            <template slot="thead">
              <vs-th sort-key="contractNo">{{ $t("sections.accounting.dataForm.contractNo") }}</vs-th>
              <vs-th sort-key="contractDate">{{ $t("sections.accounting.dataForm.contractDate") }}</vs-th>
              <vs-th sort-key="contractName">{{ $t("sections.accounting.dataForm.contractName") }}</vs-th>
              <vs-th sort-key="loanType" >{{ $t("sections.accounting.dataForm.loan.loanType") }}</vs-th>
              <vs-th sort-key="contractAmount">{{ $t("sections.accounting.dataForm.contractAmount") }}</vs-th>
              <vs-th sort-key="contractStatus">{{ $t("sections.accounting.dataForm.contractStatus") }}</vs-th>
              <vs-th sort-key="contractCloseDate">{{ $t("sections.accounting.dataForm.contractCloseDate") }}</vs-th>
              <vs-th sort-key="" class="w-1/12"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.contractNo">
                  {{ tr.contractNo }} <b><u>{{ tr.contractSeq }}</u></b>&nbsp;<b><u>{{ tr.contractCloseSeq }}</u></b>
                </vs-td>
                <vs-td :data="tr.contractDate">
                  {{ tr.contractDate | convYYYYMMDDToDDMMYYYY }}
                </vs-td>
                <vs-td :data="tr.contractName">
                  {{ tr.contractName }}
                </vs-td>
                <vs-td :data="tr.loan.loanType">
                  {{ tr.loan.loanType | loanType}}
                </vs-td>
                <vs-td :data="tr.contractAmount">
                  {{ tr.contractAmount | numberFormat  }}
                </vs-td>
                <vs-td :data="tr.contractStatus">
                  <a @click="contractStatusTransaction(tr)">{{ tr.contractStatus | contractStatus }} </a>
                </vs-td>
                <vs-td :data="tr.contractCloseDate">
                  {{ tr.contractCloseDate | convYYYYMMDDToDDMMYYYY }}
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                    <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-printer" @click="print(tr.id)" ></vs-button>
                    <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-eye" v-if="pms ('AccountingContract', 'edit', 'b')" @click="viewContract(tr.id)"></vs-button>
                    <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-eye" v-if="pms ('AccountingContract', 'edit', 'b')" @click="viewDetail(tr.id)"></vs-button>
                    <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-eye" v-if="pms ('AccountingContract', 'edit', 'b')" @click="viewTransaction(tr.id)"></vs-button>
                    <!-- <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-eye" v-if="pms ('AccountingContract', 'edit', 'b')" @click="viewEir(tr.id)"></vs-button> -->
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
</template>

<script>
import { createNamespacedHelpers  } from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')
export default {
  async created () {
    const vm = this
    await vm.getContractsAdministrator()
  },
  computed: {
    ...mapAccountingState(['contracts', 'status']),
  },
  methods: {
    ...mapAccountingActions(['getContractsAdministrator']),
    async print (id) {
      this.$router.push({ name: 'accounting-contract-Print', params: {id: id} })
    }, // viewDetail
    async viewContract (id) {
      this.$router.push({ name: 'accounting-contract-edit', params: {id: id} })
    },
    async viewDetail (id) {
      this.$router.push({ name: 'accounting-contract-detail', params: {id: id} })
    },
    async viewTransaction (id) {
      this.$router.push({ name: 'accounting-transaction-view', params: {id: id} })
    },
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>

<style>

</style>
